<i18n>
{
    "en": {
        "Day": "Day",
		"Month": "Month"
    },
    "vi": {
        "Day": "Ngày",
		"Month": "Tháng"
	}
		
}
</i18n>

<template>
	<div class="select-day-of-month flex flex-wrap sm:flex-no-wrap w-full">
		<div :class="['', { 'order-first mb-3 sm:mb-0 sm:mr-3': $i18n.locale === 'vi' }]">
			<cbs-select-month filterable name="month12" class="w-full" v-validate="required" v-model="localByMonthValue" :data-vv-as="$t(monthLabel)" :placeholder="monthPlaceholder" />
			<span class="text-danger text-sm break-normal" v-show="errors.has('month12')">{{ errors.first("month12") }}</span>
		</div>
		<div :class="['', { 'mb-3': $i18n.locale !== 'vi' }]">
			<cbs-select-number name="ByMonthDay" filterable class="w-full" v-validate="required" v-model="localByMonthDayValue" :data-vv-as="dayLabel" :placeholder="dayPlaceholder" />
			<span class="text-danger text-sm break-normal" v-show="errors.has('ByMonthDay')">{{ errors.first("ByMonthDay") }}</span>
		</div>
	</div>
</template>

<script>
import CbsSelectMonth from "@/components/cbs-select-month/CbsSelectMonth";
import CbsSelectNumber from "@/components/cbs-select-number/CbsSelectNumber";

export default {
	name: "SelectDayOfMonth",
	inject: ["parentValidator"],
	components: {
		CbsSelectMonth,
		CbsSelectNumber
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		dayLabel: {
			type: String,
			default: "Day"
		},
		monthLabel: {
			type: String,
			default: "Month"
		},
		dayPlaceholder: String,
		monthPlaceholder: String,
		required: {
			type: String,
			default: ""
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localByMonthValue: {
			get() {
				return this.localValue.bymonth;
			},
			set(val) {
				this.localValue = {
					...this.localValue,
					bymonth: val
				};
			}
		},
		localByMonthDayValue: {
			get() {
				return this.localValue.bymonthday;
			},
			set(val) {
				this.localValue = {
					...this.localValue,
					bymonthday: val
				};
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>
